export default function getCookie(name) {
  const cookie = document.cookie.split('; ').find(row => row.startsWith(name));
  if (!cookie) {
    return;
  }
  return cookie.split('=')[1];
}
